import React from 'react';
import { useHistory } from 'react-router-dom';

export default function NotFound() {
	const history = useHistory();

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '80vh',
				color: '#fff',
				textAlign: 'center',
			}}
		>
			<h1 style={{ fontSize: '4rem', marginBottom: '1rem' }}>404</h1>
			<h2 style={{ marginBottom: '1rem' }}>Page Not Found</h2>
			<p style={{ marginBottom: '2rem', color: '#aaa' }}>
				The page you're looking for doesn't exist or has been moved.
			</p>
			<button
				onClick={() => history.goBack()}
				style={{
					padding: '12px 24px',
					backgroundColor: '#DBB42C',
					color: '#0a1628',
					border: 'none',
					borderRadius: '8px',
					cursor: 'pointer',
					fontSize: '1rem',
					fontWeight: 'bold',
				}}
			>
				Go Back
			</button>
		</div>
	);
}
